import { Button, Grid, LinearProgress, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../api/Api";
import ItemCard from "../components/ItemCard";
import { UserContext } from "../context/UserContextProvider";

const EarningHistoryPage = () => {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const [itemList, setItemList] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const getItems = async () => {
            setItemList((await Api.listCampaign(user.idem_guid)))
            setLoaded(true)
        }
        getItems();
    }, [user])

    if (!user) {
        return null;
    }

    const removeItem = (/** @type {any[]} */ item) => {
        setItemList(itemList.filter((/** @type {any} */ mItem) => mItem !== item))
    }

    return <Grid container spacing={2}>
        {!loaded && <Grid item xs={12}><LinearProgress /></Grid>}
        {itemList.length === 0 && loaded &&
            <Grid container justifyContent={'center'}>
                <Stack spacing={2}>
                    <Typography variant='h5' sx={{ color: 'white' }}>
                        No payments received!
                    </Typography>
                    <Typography variant='subtitle1' sx={{ color: 'white' }}>
                        {`You haven't earned any millix yet, want to earn some now?`}
                    </Typography>
                    <Button variant={'outlined'} onClick={() => navigate('/')}>Earn Millix</Button>
                </Stack>
            </Grid>
        }
        {itemList.length > 0 && itemList.map((/** @type {any} */ item, /** @type {import("react").Key} */ index) => <Grid key={index} item xs={12} lg={6}>
            <ItemCard item={item} onRemove={() => removeItem(item)} remove />
        </Grid>)}
    </Grid>
}

export default EarningHistoryPage;